import 'src/styles/pages/_personnel.scss';
import 'src/styles/_common.scss';
import 'src/styles/components/_subNavBar.scss';

import React, { ChangeEvent, useContext, useEffect, useRef, useState } from 'react';
import Button from 'src/components/controls/forms/redesign/FormButton';
import _ from 'lodash';
import Panel from 'src/components/common/Panel';
import Page from 'src/components/common/Page';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import useFetch from 'use-http';
import { useDispatch, useSelector } from 'react-redux';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
// import CardContainer from 'src/components/common/CardContainer.redesign';
import { IRootState } from 'src/reducers';
import { RouteComponentProps } from 'react-router-dom';
import { push } from 'connected-react-router';
import { UserRoles } from 'src/models/UserRole';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import AddPersonnelDialog from '../dialogs/AddPersonnelDialog';
import PersonnelSearch from '../components/PersonnelSearch';
import PersonnelNavBar from '../components/PersonnelNavBar';
import moment from 'moment';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import Select, { StylesConfig } from 'react-select';
import { Controller } from 'react-hook-form';
import PersonnelTaxInformationDialog from '../dialogs/taxInfo/PersonnelTaxInformationDialog';
import PersonnelCommentDialog from '../dialogs/PersonnelPerformanceDialog';
import PersonnelHiringHistoryDialog from '../dialogs/PersonnelHiringHistoryDialog';
import PersonnelAdvancedQuickFind from '../dialogs/PersonnelAdvancedQuickFindDialog';
import PersonnelToast from '../components/PersonnelToast';
import CondensedPersonnel from 'src/models/personnel/CondensedPersonnel';
import TSDILandman from 'src/models/personnel/TSDILandman';
import TSDILandmanForm from 'src/models/personnel/TSDILandmanForm';
import PersonnelOfficeLocations from 'src/models/personnel/PersonnelOfficeLocations';
import CollapsibleSection from 'src/components/common/CollapsibleSection';
import UpdateTermHireDateDialog from '../dialogs/UpdateTermHireDateDialog';
import PersonnelHiringHistory from 'src/models/personnel/PersonnelHiringHistory';
// import Personnel from 'src/models/personnel/Personnel';

type IPersonnelPageProps = RouteComponentProps<{ id?: string }>;

interface IOptionType {
    value: string | number;
    label: string;
}

type DropDownSelection = {
    code: string,
    dscr: string
};

const PersonnelPage: React.FC<IPersonnelPageProps> = (props) => {
    const { get, put, response } = useFetch();
    const { register, control, handleSubmit, errors, getValues, setValue, reset, formState, watch } = useForm();
    const { isDirty } = formState;
    const dispatch = useDispatch();
    const appContext = useContext<IAppContextState>(AppContext);

    const [states, setStates] = useState<PagedResultSet<State>>(undefined); // states for dropdown
    // const [rehireDates, setRehireDates] = useState([]);
    const [rehireDates] = useState([]); // rehireDates for personnel
    const [managerList, setManagerList] = useState<Array<IOptionType>>(); // managers
    const [isCollapsed, setIsCollapsed] = useState<boolean>(false); // old - tracking whether search area was collapsed
    // const [hasFirstOffice, setHasFirstOffice] = useState<boolean>(false);
    // const [hasSecondOffice, setHasSecondOffice] = useState<boolean>(false);
    const [toast, setToast] = useState<{ message: string; color?: string, persistent?: boolean; } | null>(null); // toast for ux
    const [personnelTypes, setPersonnelTypes] = useState<Array<DropDownSelection>>(undefined); // personnel types
    const [billingOffices, setBillingOffices] = useState<Array<DropDownSelection>>(undefined); // billing offices
    const [personnelHiringHistory, setPersonnelHiringHistory] = useState<Array<PersonnelHiringHistory>>(); // hiring history information
    // const [departments, setDepartments] = useState<Array<DropDownSelection>>(undefined);
    // const [offices, setOffices] = useState<Array<DropDownSelection>>(undefined);

    const [isLoading, setIsLoading] = useState<boolean>(false); // checks when data is loading

    const topOfPage = useRef(null); // 
    const bottomOfPage = useRef(null);

    const dncWatch = watch('doNotCall'); // watch variable to control visibility of dnc comment field

    const [dateDialogContextProp, setDateDialogContextProp] = useState<string>('');
    const [prevDateProp, setPrevDateProp] = useState<string>('');

    let selectedPersonnel = useSelector((state: IRootState) => state.personnel.selectedPersonnel); // Personnel selected by the user
    const [selectedPersonnelProp, setSelectedPersonnelProp] = useState<TSDILandman>(null); // refresh prop for dialogs to refresh data (using the selectedPersonnel above didn't work 100% of the time)

    // stylization for select dropdown menu (manager, hireby, etc.)
    const customStyles: StylesConfig<IOptionType, false> = {
        control: (provided) => ({
            ...provided,
            minHeight: '30px',
            height: '30px',
            padding: '0px',
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0px 8px',
            height: '30px',
            flex: 1,
        }),
        input: (provided) => ({
            ...provided,
            margin: '0px',
            padding: '0px',
            flex: 1,
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '30px',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0px',
        }),
        clearIndicator: (provided) => ({
            ...provided,
            padding: '0px',
        }),
    };

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (!!rehireDates) {
            console.log('====> RehireDates = ', rehireDates);
        }
    }, [rehireDates]);

    // SelectedPersonnel will change when the user clicks on a user or on initial render, if url contains an id
    useEffect(() => {
        if (!!selectedPersonnel) {
            getHiringHistory();
        }
    }, [selectedPersonnel]);

    useEffect(() => {
        refreshPersonnel();
    }, [personnelHiringHistory]);

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = async () => {
        console.log('PersonnelPage onCreate()');
        setIsLoading(true);
        await getManagers();
        await getStates();
        await getPersonnelTypes();
        await getBillingOffices();
        // await getDepartments();
        // await getOffices();
        if (!!selectedPersonnel) {
            getHiringHistory();
        }
        setIsLoading(false);
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('PersonnelPage onDestroy()');
    };

    // refreshes personnel after selectedPersonnel changes (will only refresh once hiring history is retrieved to ensure proper information is populated)
    const refreshPersonnel = async () => {
        // await getHiringHistory();
        getManagers();
        showPersonnelData(selectedPersonnel);
        reset(initializeData(selectedPersonnel));
        setSelectedPersonnelProp(selectedPersonnel);
        console.log('====> SelectedPersonnel = ', selectedPersonnel);
    };

    // displays information toast
    const showToast = (message: string, color?: string, persistent?: boolean) => {
        setToast({ message, persistent, color });
    };

    // retirves and maps personnel types
    const getPersonnelTypes = async () => {
        let result = await get(`/v1.0/landmen/landman-types`);
        if (response.ok && result.length > 0) {
            setPersonnelTypes(result?.map((ct: DropDownSelection) => {
                return { code: ct.code, dscr: ct.dscr };
            }));
        } else {
            console.log('error with get: ', response);
        }
    };

    // maps options for personnel type dropdown
    const personnelTypeDropdown = () => {
        return personnelTypes
            ? personnelTypes?.map((ct: DropDownSelection) => {
                return { value: ct.code, label: ct.dscr };
            })
            : [];
    };

    // retrieves and maps billing offices
    const getBillingOffices = async () => {
        let result = await get(`/v1.0/landmen/billing-offices`);
        if (response.ok && result) {
            setBillingOffices(result.map((ct: DropDownSelection) => {
                return { code: ct.code, dscr: ct.dscr };
            }));
        } else {
            console.log('error with get: ', response);
        }
    };

    // maps options for billing office dropdown
    const billingOfficeDropdown = () => {
        return billingOffices
            ? billingOffices?.map((ct: DropDownSelection) => {
                return { value: ct.code, label: ct.dscr };
            })
            : [];
    };

    /**
     * Gets the list of United States (Merica) not React states
     */
    const getStates = async () => {
        let result = await get('/v1.0/states');

        if (response.ok) {
            setStates(result);
        } else {
            showToast('Unable to get the States Data', `rgba(255,0,0,0.5)`);
        }
    };

    /**
     * @returns United States (Merica) not React states
     */
    const stateDropdownOptions = () => {
        return states
            ? states?.items?.map((st: State) => {
                return { value: st.abbreviation, label: st.name };
            })
            : [];
    };

    // const getDepartments = async () => {
    //     let result = await get(`/v1.0/landmen/get-departments`);
    //     if (response.ok && result) {
    //         setDepartments(result.map((ct: DropDownSelection) => {
    //             return { code: ct.code, dscr: ct.dscr };
    //         }));
    //     } else {
    //         console.log('error with get: ', response);
    //     }
    // };

    // const getOffices = async () => {
    //     let result = await get(`/v1.0/landmen/get-offices`);
    //     if (response.ok && result) {
    //         setOffices(result.map((ct: DropDownSelection) => {
    //             return { code: ct.code, dscr: ct.dscr };
    //         }));
    //     } else {
    //         console.log('error with get: ', response);
    //     }
    // };

    /**
     * @returns list of personnel with hiring permissions
     */
    const getManagers = async () => {
        var managers = await get(`v1.0/landmen/personnel/get-managers`) as unknown as Array<CondensedPersonnel>;

        if (response.ok && managers) {
            setManagerList(managers?.
                sort((a: CondensedPersonnel, b: CondensedPersonnel) => { // sort by last name
                    if (a.lastName < b.lastName) {
                        return -1;
                    }
                    if (a.lastName > b.lastName) {
                        return 1;
                    }
                    return 0;
                }).
                filter((ct: CondensedPersonnel) =>
                    selectedPersonnel?.hireBy ? ct.isActive === true || ct.tsdNo === selectedPersonnel?.hireBy : ct.isActive === true // adding back in old managers for record keeping
                ).
                map((st: CondensedPersonnel) => { // map for select list
                    return { value: st.tsdNo, label: st.firstName + ' ' + st.lastName };
                }));
        } else {
            showToast('Unable to fetch managers', `rgba(255,0,0,0.5)`);
        }

    };

    /**
     * @returns boolean determining if the personnel performance button should be disabled based on current user role
     */
    const canViewPerformanceComments = (): boolean => {
        let contractorRoles = ['Contractor (Landman)', 'Cartographer', 'Contractor (Super User)'];
        let noPCAccessRoles = ['Admin', 'Prospect Manager', 'HR Admin', 'Project Coordinator', 'HR Admin', 'HR', 'Accounting Admin', 'Accounting', 'Client User'];

        if (contractorRoles.includes(selectedPersonnel.userRole)) {
            return false;
        }

        if (
            noPCAccessRoles.includes(selectedPersonnel.userRole) &&
            appContext.currentUser.role !== UserRoles.ProjectCoordinator ||
            appContext.currentUser.role !== UserRoles.ProspectManager
        ) {
            return false;
        }

        return true;
    };

    /**
     * @param data - The selected Personnel data from the list
     * @returns New data after manipulation(s) needed for the form
     */
    const initializeData = (data: TSDILandman) => {
        let newData: TSDILandmanForm = { ...data };

        // dates
        newData.hireDate = newData.hireDate ? (moment(newData.hireDate).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.wlDate = newData.wlDate ? (moment(newData.wlDate).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.haspOut = newData.haspOut ? (moment(newData.haspOut).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.haspIn = newData.haspIn ? (moment(newData.haspIn).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.rH2Date = newData.rH2Date ? (moment(newData.rH2Date).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.rH3Date = newData.rH3Date ? (moment(newData.rH3Date).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.lastWorked = newData.lastWorked ? (moment(newData.lastWorked).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.birthDate = newData.birthDate ? (moment(newData.birthDate).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.modDate = newData.modDate ? (moment(newData.modDate).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.incorporatedDate = newData.incorporatedDate ? (moment(newData.incorporatedDate).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.lmCorpTypeDate = newData.lmCorpTypeDate ? (moment(newData.lmCorpTypeDate).format('YYYY-MM-DD') as unknown as Date) : null;

        if (newData.lastWorkedInfo !== undefined && newData.lastWorkedInfo !== null) {
            newData.lastWorkedInfo.lastWorkDate = newData.lastWorkedInfo?.lastWorkDate ? (moment(newData.lastWorkedInfo.lastWorkDate).format('YYYY-MM-DD') as unknown as Date) : null;
        }

        // phone numbers
        newData.homePh = newData.homePh ? newData.homePh.replace(/\D/g, '') : null;
        newData.homePh = newData.homePh ? `(${newData.homePh.slice(0, 3)}) ${newData.homePh.slice(3, 6)}-${newData.homePh.slice(6)}` : null;
        newData.cellular = newData.cellular ? newData.cellular.replace(/\D/g, '') : null;
        newData.cellular = newData.cellular ? `(${newData.cellular.slice(0, 3)}) ${newData.cellular.slice(3, 6)}-${newData.cellular.slice(6)}` : null;
        newData.emergencyPh = newData.emergencyPh ? newData.emergencyPh.replace(/\D/g, '') : null;
        newData.emergencyPh = newData.emergencyPh ? `(${newData.emergencyPh.slice(0, 3)}) ${newData.emergencyPh.slice(3, 6)}-${newData.emergencyPh.slice(6)}` : null;

        // term / rehire date
        newData.termDate = newData.termDate ? (moment(newData.termDate).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.rH1Date = newData.rH1Date ? (moment(newData.rH1Date).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.rH2Date = newData.rH2Date ? (moment(newData.rH2Date).format('YYYY-MM-DD') as unknown as Date) : null;
        newData.rH3Date = newData.rH3Date ? (moment(newData.rH3Date).format('YYYY-MM-DD') as unknown as Date) : null;

        // get filtered termination dates
        let lastTermDate = null;

        if (personnelHiringHistory !== null && personnelHiringHistory !== undefined && personnelHiringHistory?.length > 0) {
            let filteredTerm = personnelHiringHistory?.filter((a: PersonnelHiringHistory) => a.tranType === 'Termed');

            if (filteredTerm?.length === 1) {
                lastTermDate = (moment(filteredTerm[0].tranDate).format('YYYY-MM-DD') as unknown as Date);
            } else if (filteredTerm?.length > 1) {
                lastTermDate = (moment(filteredTerm[filteredTerm?.length - 1].tranDate).format('YYYY-MM-DD') as unknown as Date);
            } else {
                lastTermDate = null;
            }
        }

        // get filtered rehire dates
        let lastRehireDate = null;

        if (personnelHiringHistory !== null && personnelHiringHistory !== undefined && personnelHiringHistory?.length > 0) {
            let filteredRehire = personnelHiringHistory?.filter((a: PersonnelHiringHistory) => a.tranType === 'Hired');

            // can only be a rehire if there is a second hire date in the table ... will show initial hire as a rehire otherwise
            if (filteredRehire?.length === 2) {
                lastRehireDate = (moment(filteredRehire[1].tranDate).format('YYYY-MM-DD') as unknown as Date);
            } else if (filteredRehire?.length > 2) {
                lastRehireDate = (moment(filteredRehire[filteredRehire?.length - 1].tranDate).format('YYYY-MM-DD') as unknown as Date);
            } else {
                lastRehireDate = null;
            }
        }
        // check if term date exists
        if (newData.termDate !== null) {
            if (newData.termDate > lastTermDate || lastTermDate === null) {
                newData.termDate = newData.termDate;
            } else {
                newData.termDate = lastTermDate;
            }
        } else {
            newData.termDate = lastTermDate;
        }

        // check if rehireDate exists
        if (newData.rH1Date !== null || newData.rH2Date !== null || newData.rH3Date !== null) {
            let latestStoredRehire = null;
            if (newData.rH1Date !== null) {
                latestStoredRehire = newData.rH1Date;
            }
            if (newData.rH2Date !== null) {
                latestStoredRehire = newData.rH2Date;
            }
            if (newData.rH3Date !== null) {
                latestStoredRehire = newData.rH3Date;
            }

            if (latestStoredRehire > lastRehireDate || lastRehireDate === null) {
                newData.rH1Date = latestStoredRehire;
            } else {
                newData.rH1Date = lastRehireDate;
            }
        } else {
            newData.rH1Date = lastRehireDate;
        }

        // work locations

        // if (data.officeLocations.length === 2) {
        //     newData.office1Name = data.officeLocations[0].id;
        //     newData.office1Ext = data.officeLocations[0].extension;
        //     newData.office2Name = data.officeLocations[1].id;
        //     newData.office2Ext = data.officeLocations[1].extension;
        //     setHasFirstOffice(true);
        // } else if (data.officeLocations.length === 1) {
        //     newData.office1Name = data.officeLocations[0].id;
        //     newData.office1Ext = data.officeLocations[0].extension;
        //     setHasFirstOffice(true);
        // } else {
        //     setHasFirstOffice(false);
        // }

        return newData;
    };

    /**
     * Called when Save button is clicked
     * @param data Personnel information from the form
     */
    const onSubmit = async (data: TSDILandmanForm) => {
        console.log('Personnel Page onSubmit() ;D', data);
        if (!!data) {
            updatePersonnel(finalizeData(data));
        }
    };

    /**
     * This helps finalize the data to save / send to the LandmanController
     * @param data - The Personnel Model populated by the form
     * @returns - Updated Personnel data from the form 
     */
    const finalizeData = (data: TSDILandmanForm) => {
        let finalData: TSDILandman = { ...data, officeLocations: null };
        finalData.officeLocations = new Array<PersonnelOfficeLocations>();

        finalData.type = finalData.type === '' || finalData.type === undefined ? null : finalData.type;
        finalData.active = !!finalData.active;
        finalData.doNotCall = !!finalData.doNotCall;
        finalData.fName = finalData.fName === '' || finalData.fName === undefined ? null : finalData.fName;
        finalData.mName = finalData.mName === '' || finalData.mName === undefined ? null : finalData.mName;
        finalData.lName = finalData.lName === '' || finalData.lName === undefined ? null : finalData.lName;
        finalData.akaName = finalData.akaName === '' || finalData.akaName === undefined ? null : finalData.akaName;
        finalData.corpName = finalData.corpName === '' || finalData.corpName === undefined ? null : finalData.corpName;

        finalData.email1 = finalData.email1 === '' || finalData.email1 === undefined ? null : finalData.email1;
        finalData.email2 = finalData.email2 === '' || finalData.email2 === undefined ? null : finalData.email2;
        finalData.homePh = finalData.homePh === '' || finalData.homePh === undefined ? null : finalData.homePh.replace(/\D/g, '');
        finalData.cellular = finalData.cellular === '' || finalData.cellular === undefined ? null : finalData.cellular.replace(/\D/g, '');
        finalData.addr1 = finalData.addr1 === '' || finalData.addr1 === undefined ? null : finalData.addr1;
        finalData.addr2 = finalData.addr2 === '' || finalData.addr2 === undefined ? null : finalData.addr2;
        finalData.zip1 = finalData.zip1 === '' || finalData.zip1 === undefined ? null : finalData.zip1;
        finalData.city = finalData.city === '' || finalData.city === undefined ? null : finalData.city;
        finalData.state = finalData.state === '' || finalData.state === undefined ? null : finalData.state;

        finalData.offAddr1 = finalData.offAddr1 === '' || finalData.offAddr1 === undefined ? null : finalData.offAddr1;
        finalData.offAddr2 = finalData.offAddr2 === '' || finalData.offAddr2 === undefined ? null : finalData.offAddr2;
        finalData.offZip1 = finalData.offZip1 === '' || finalData.offZip1 === undefined ? null : finalData.offZip1;
        finalData.offCity = finalData.offCity === '' || finalData.offCity === undefined ? null : finalData.offCity;
        finalData.offState = finalData.offState === '' || finalData.offState === undefined ? null : finalData.offState;

        finalData.contact = finalData.contact === '' || finalData.contact === undefined ? null : finalData.contact;
        finalData.emergencyPh = finalData.emergencyPh === '' || finalData.emergencyPh === undefined ? null : finalData.emergencyPh.replace(/\D/g, '');

        finalData.hireBy = finalData.hireBy ? parseInt(finalData.hireBy?.toString(), 10) : null;
        finalData.haspKey = finalData.haspKey === '' || finalData.haspKey === undefined ? null : finalData.haspKey;
        finalData.contractorPayType = finalData.contractorPayType === '' || finalData.contractorPayType === undefined ? null : finalData.contractorPayType;
        finalData.hireDate = finalData.hireDate?.toString() === '' || finalData.hireDate === undefined ? null : finalData.hireDate;
        finalData.modDate = finalData.modDate?.toString() === '' || finalData.modDate === undefined ? null : finalData.modDate;
        finalData.haspIn = finalData.haspIn?.toString() === '' || finalData.haspIn === undefined ? null : finalData.haspIn;

        // most recent term date
        finalData.termDate = finalData.termDate?.toString() === '' || finalData.termDate === undefined
            ? (selectedPersonnel.termDate ?? null)
            : finalData.termDate;

        // slotting in most recent rehire date without duplications
        let currentRehireDate = finalData.rH1Date;
        let originalrH1Date = selectedPersonnel.rH1Date ?? null;
        let originalrH2Date = selectedPersonnel.rH2Date ?? null;
        let originalrH3Date = selectedPersonnel.rH3Date ?? null;

        if (!originalrH1Date) {
            finalData.rH1Date = currentRehireDate;
            finalData.rH2Date = originalrH2Date;
            finalData.rH3Date = originalrH3Date;
        } else if (!originalrH2Date && originalrH1Date !== currentRehireDate) {
            finalData.rH1Date = originalrH1Date;
            finalData.rH2Date = currentRehireDate;
            finalData.rH3Date = originalrH3Date;
        } else if (!originalrH3Date && originalrH2Date !== currentRehireDate) {
            finalData.rH1Date = originalrH1Date;
            finalData.rH2Date = originalrH2Date;
            finalData.rH3Date = currentRehireDate;
        } else {
            finalData.rH1Date = originalrH1Date;
            finalData.rH2Date = originalrH2Date;
            finalData.rH3Date = originalrH3Date;
        }

        finalData.activeComment = finalData.activeComment === '' || finalData.activeComment === undefined ? null : finalData.activeComment;
        finalData.lastWorked = finalData.lastWorked?.toString() === '' || finalData.lastWorked === undefined ? null : finalData.lastWorked;
        finalData.jobCategory = !!finalData.jobCategory;
        finalData.inelligible = !!finalData.inelligible;

        finalData.billingOffice = finalData.billingOffice === '' || finalData.billingOffice === undefined ? null : finalData.billingOffice;
        finalData.omitTeServices = !!finalData.omitTeServices;
        finalData.omitTsCorpName = !!finalData.omitTsCorpName;

        if (finalData.lastWorkedInfo) {
            finalData.lastWorkedInfo.lastWorkDate =
                finalData.lastWorkedInfo.lastWorkDate.toString() === '' ||
                    finalData.lastWorkedInfo.lastWorkDate === undefined
                    ? null
                    : finalData.lastWorkedInfo.lastWorkDate;

            finalData.lastWorkedInfo.lastPeriod =
                finalData.lastWorkedInfo.lastPeriod.toString() === '' ||
                    finalData.lastWorkedInfo.lastPeriod === undefined ||
                    isNaN(Number(finalData.lastWorkedInfo.lastPeriod))
                    ? null
                    : Number(finalData.lastWorkedInfo.lastPeriod);

            finalData.lastWorkedInfo.lastClNo =
                finalData.lastWorkedInfo.lastClNo.toString() === '' ||
                    finalData.lastWorkedInfo.lastClNo === undefined ||
                    isNaN(Number(finalData.lastWorkedInfo.lastClNo))
                    ? null
                    : Number(finalData.lastWorkedInfo.lastClNo);

            finalData.lastWorkedInfo.lastPrNo =
                finalData.lastWorkedInfo.lastPrNo?.toString() === '' ||
                    finalData.lastWorkedInfo.lastPrNo === undefined ||
                    isNaN(Number(finalData.lastWorkedInfo.lastPrNo))
                    ? null
                    : Number(finalData.lastWorkedInfo.lastPrNo);

            finalData.lastWorkedInfo.lastManager =
                finalData.lastWorkedInfo.lastManager === '' ||
                    finalData.lastWorkedInfo.lastManager === undefined
                    ? null
                    : finalData.lastWorkedInfo.lastManager;

            finalData.lastWorkedInfo.lastCounty =
                finalData.lastWorkedInfo.lastCounty === '' ||
                    finalData.lastWorkedInfo.lastCounty === undefined
                    ? null
                    : finalData.lastWorkedInfo.lastCounty;
        }

        // not mapped
        finalData.lmNo = selectedPersonnel.lmNo;
        finalData.tsdNo = selectedPersonnel.tsdNo;
        finalData.zip2 = selectedPersonnel.zip2;
        finalData.offPh = selectedPersonnel.offPh;
        finalData.fax = selectedPersonnel.fax;
        finalData.pager = selectedPersonnel.pager;
        finalData.foPhone = selectedPersonnel.foPhone;
        finalData.fHPhone = selectedPersonnel.fHPhone;
        finalData.oTHPhone = selectedPersonnel.oTHPhone;
        finalData.cplNo = selectedPersonnel.cplNo;
        finalData.taxId = selectedPersonnel.taxId;
        finalData.chkDest = selectedPersonnel.chkDest;
        finalData.chkAddr1 = selectedPersonnel.chkAddr1;
        finalData.chkAddr2 = selectedPersonnel.chkAddr2;
        finalData.chkCity = selectedPersonnel.chkCity;
        finalData.chkState = selectedPersonnel.chkState;
        finalData.chkZip1 = selectedPersonnel.chkZip1;
        finalData.chkZip2 = selectedPersonnel.chkZip2;
        finalData.bTabsUser = selectedPersonnel.bTabsUser;
        finalData.taxAddr1 = selectedPersonnel.taxAddr1;
        finalData.taxAddr2 = selectedPersonnel.taxAddr2;
        finalData.taxAddr3 = selectedPersonnel.taxAddr3;
        finalData.taxCity = selectedPersonnel.taxCity;
        finalData.taxState = selectedPersonnel.taxState;
        finalData.taxZip1 = selectedPersonnel.taxZip1;
        finalData.taxZip2 = selectedPersonnel.taxZip2;
        finalData.userGroupType = selectedPersonnel.userGroupType;
        finalData.lmCorpType = selectedPersonnel.lmCorpType;
        finalData.aaplNo = selectedPersonnel.aaplNo;
        finalData.chkAddr3 = selectedPersonnel.chkAddr3;
        finalData.birthDate = selectedPersonnel.birthDate;
        finalData.salutation = selectedPersonnel.salutation;
        finalData.incorporatedDate = selectedPersonnel.incorporatedDate;
        finalData.bankAcctNo = selectedPersonnel.bankAcctNo;
        finalData.bankAcctType = selectedPersonnel.bankAcctType;
        finalData.rH2Date = selectedPersonnel.rH2Date;
        finalData.rH3Date = selectedPersonnel.rH3Date;
        finalData.ssn = selectedPersonnel.ssn;
        finalData.offZip2 = selectedPersonnel.offZip2;
        finalData.manager = selectedPersonnel.manager;
        finalData.useSsn = selectedPersonnel.useSsn;
        finalData.wlMgr = selectedPersonnel.wlMgr;
        finalData.region = selectedPersonnel.region;
        finalData.bankRouting = selectedPersonnel.bankRouting;
        finalData.deptNo = selectedPersonnel.deptNo;
        finalData.wlDate = selectedPersonnel.wlDate;
        finalData.wLLoca = selectedPersonnel.wLLoca;
        finalData.ownUser = selectedPersonnel.ownUser;
        finalData.ownPass = selectedPersonnel.ownPass;
        finalData.haspOut = selectedPersonnel.haspOut;
        finalData.county = selectedPersonnel.county;

        console.log('final data: ', finalData);

        return finalData;
    };

    /**
     * Saves Personnel information
     * @param data Personnel information from the form
     */
    const updatePersonnel = async (data: TSDILandman) => {
        let result = await put(`/v1.0/landmen/update-tsdi-landman`, data);

        if (response.ok) {
            showToast('Personnel updated successfully');
            selectedPersonnel = data;
            setSelectedPersonnelProp(selectedPersonnel);
            reset(initializeData(data));
        } else if (result?.messageCode === '15') {
            showToast('Update personnel failed', `rgba(255,0,0,0.5)`);
        } else {
            showToast('Update personnel failed', `rgba(255,0,0,0.5)`);
        }
    };

    // start dialog triggers
    const addPersonnel = () => {
        dispatch(actions.layout.showDialog(DialogList.ADD_PERSONNEL));
    };

    const showPersonnelTaxInfo = () => {
        dispatch(actions.layout.showDialog(DialogList.PERSONNEL_TAX_INFORMATION));
    };

    const showPerformanceComments = () => {
        dispatch(actions.layout.showDialog(DialogList.PERSONNEL_PERFORMANCE_COMMENTS));
    };

    const showHiringHistoryInfo = () => {
        dispatch(actions.layout.showDialog(DialogList.PERSONNEL_HIRING_HISTORY));
    };

    const showTermRehireDateDialog = (context: string) => {
        setDateDialogContextProp(context);
        const values = getValues();

        if (context === 'Termination') {
            setPrevDateProp(values.termDate);
        } else {
            setPrevDateProp(values.rH1Date);
        }

        dispatch(actions.layout.showDialog(DialogList.UPDATE_TERM_HIRE_DATE));
    };

    const toggleAdvancedQuickFind = () => {
        dispatch(actions.layout.showDialog(DialogList.PERSONNEL_ADVANCED_QUICK_FIND));
    };

    const hideDialog = (location?: string) => {
        dispatch(actions.layout.hideDialog());

        if (location === 'tax-information') {
            showToast('Tax information updated successfully');
        }
    };

    // end dialog triggers

    // closes validation dialog for rehire / termindation dates and refreshes data
    const finalizeTermRehireUpdate = () => {
        getHiringHistory();
        hideDialog();
    };

    // gets hiring history for personnel
    const getHiringHistory = async () => {
        let result = await get(`/v1.0/landmen/personnel/${selectedPersonnel?.tsdNo}/get-hire-history`);
        if (response.ok) {
            if (result) {
                result?.forEach((history: PersonnelHiringHistory) => {
                    history.tranDate = history.tranDate ? (moment(history.tranDate).format('YYYY-MM-DD') as unknown as Date) : null;
                    history.tranType = history.tranType ? (history.tranType === 'H' ? 'Hired' : (history.tranType === 'T' ? 'Termed' : 'n/a')) : 'n/a';
                });

                setPersonnelHiringHistory(result);
            }
        } else {
            console.log('error with get: ', response);
        }
    };

    /**
     * Sets the selected Personnel to the store if the given ID is valid and it's not already the same personnel
     * @param personnel - personnel payload
     */
    const setSelectedPersonnel = (personnel: TSDILandman) => {
        if (personnel) {
            personnel?.lmNo !== selectedPersonnel?.lmNo
                ? dispatch({ type: '[personnel] SET_SELECTED_PERSONNEL', payload: personnel })
                : showToast('Selected personnel already set', `rgba(78,117,154,0.5)`);

            setSelectedPersonnelProp(personnel);
        } else {
            showToast('Selected personnel is undefined', `rgba(255,0,0,0.5)`);
        }
    };

    /**
     * Visually displays the given Personnel information to the form fields
     * @param selected - The selected Personnel
     */
    const showPersonnelData = (selected: TSDILandman) => {
        // setDisplayInfo(true);
        if (selected?.lmNo && selected?.lmNo !== selectedPersonnel?.lmNo) {
            setSelectedPersonnel(selected);
            if (!selectedPersonnel && !parseInt(props?.match?.params?.id, 10)) {
                dispatch(push(`${selected.lmNo}/home`));
            }
        } else {
            console.log('Selected Personnel already set');
        }
    };

    // const departmentsDropdown = () => {
    //     return departments
    //         ? departments?.map((ct: DropDownSelection) => {
    //             return { value: ct.code, label: ct.dscr };
    //         })
    //         : [];
    // };

    // const officeDropdown = () => {
    //     return offices
    //         ? offices?.map((ct: DropDownSelection) => {
    //             return { value: ct.code, label: ct.dscr };
    //         })
    //         : [];
    // };

    // automatically retrives city and state based off zip code
    const getCityState = async (zipCode: string) => {
        const result = await get(`v1.0/usps/${zipCode}/local-source`);
        console.log(result);

        if (response.ok) {
            setValue('state', result.zipCode.state);
            setValue('city', result.zipCode.city);
        }
    };

    // triggers city / state recall from the zipcode
    const handleZipcodeChange = (e: ChangeEvent<HTMLInputElement>) => {
        let zipCode: string = e.target.value;

        if (zipCode.length === 5) {
            getCityState(zipCode);
        }
    };

    // formats the phone number entered
    const formatPhoneNumber = (fieldName: string) => {
        let phoneNumber = getValues(fieldName);
        phoneNumber = phoneNumber.replace(/\D/g, '');

        if (phoneNumber.length !== 10) {
            return;
        }

        phoneNumber = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
        setValue(fieldName, phoneNumber);
    };

    // const toggleFirstOffice = (e: React.FormEvent<HTMLSelectElement>) => {
    //     setHasFirstOffice(true);
    // };

    // const toggleSecondOffice = (e: React.FormEvent<HTMLSelectElement>) => {
    //     setHasSecondOffice(true);
    // };

    // BEGINNING OF PAGE:
    return (
        // <div style={{ overflowY: 'hidden' }}>
        <div>
            <PersonnelNavBar />
            <div>
                {toast && (
                    <PersonnelToast
                        message={toast.message}
                        color={toast.color}
                        onClose={() => setToast(null)}
                        persistent={toast.persistent}
                    />
                )}
            </div>
            {(isDirty) && (
                <>
                    <div
                        id="dirtyFlag"
                        style={{
                            top: '2.5rem',
                            left: '0',
                            width: '100%',
                            height: '3rem',
                            color: 'white',
                            backgroundColor: `rgba(255, 0, 0, 0.5)`,
                            zIndex: 9000,
                            padding: '1rem 0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <div>Unsaved Changes - Please Save Before Leaving Form</div>
                    </div>
                </>
            )}
            <PersonnelSearch
                showPersonnelData={showPersonnelData}
                setIsCollapsed={setIsCollapsed}
                toggleAdvancedQuickFind={toggleAdvancedQuickFind}
            />
            <form id="personnelForm" onSubmit={handleSubmit(onSubmit)}>
                <Page>
                    {selectedPersonnel && <Page.Section width={2}>
                        <div id="sidebar">
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={selectedPersonnel ? `${selectedPersonnel?.akaName ? selectedPersonnel?.akaName : selectedPersonnel?.fName + ' ' + selectedPersonnel?.lName}` : 'Personnel Profile'} height="100%">
                                    <div className={isCollapsed ? 'profile' : 'profile-with-search'}>
                                        <div style={{ margin: '1.5rem 0' }}>
                                            <RHFSelect
                                                bodyStyle={{ marginBottom: '1rem' }}
                                                name="type"
                                                label="Status"
                                                options={personnelTypeDropdown()}
                                                register={register}
                                                errors={errors}
                                            />
                                            <RHFCheckbox
                                                name="active"
                                                label="Active"
                                                style={{ verticalAlign: 'middle' }}
                                                register={register}
                                                errors={errors}
                                            />
                                            <RHFCheckbox
                                                name="doNotCall"
                                                label="Do Not Call"
                                                style={{ verticalAlign: 'middle' }}
                                                register={register}
                                                errors={errors}
                                            />
                                            <div style={{ paddingTop: '5px' }}>
                                                <RHFTextArea
                                                    style={{ marginTop: '1rem', width: '100%', height: '25%' }}
                                                    name="activeComment"
                                                    label="DNC Comment"
                                                    register={register}
                                                    errors={errors}
                                                    maxLength={80} // max length is 80 in db
                                                    isRequired={dncWatch}
                                                />
                                            </div>
                                            <div style={{ paddingTop: 'auto' }}>
                                                {/* <RHFInputBox
                                                    style={{ width: '100%' }}
                                                    name="lmNo"
                                                    label="LM No"
                                                    register={register}
                                                    errors={errors}
                                                    disabled={true}
                                                /> */}
                                                <RHFInputBox
                                                    style={{ width: '100%' }}
                                                    name="tsdNo"
                                                    label="LM No"
                                                    register={register}
                                                    errors={errors}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel>
                                    <Button
                                        className="blue-hover-button"
                                        text="Save"
                                        type="submit"
                                        intent="primary"
                                        form="personnelForm"
                                        style={{ width: '90%', marginTop: '1rem', marginLeft: '1rem', marginRight: '1rem' }}
                                        disabled={isLoading}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '90%', marginTop: '1rem', marginLeft: '1rem', marginRight: '1rem' }}
                                        text={'Tax Info / Checking'}
                                        onClick={() => showPersonnelTaxInfo()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '90%', marginTop: '1rem', marginLeft: '1rem', marginRight: '1rem' }}
                                        text={'Hiring History'}
                                        onClick={() => showHiringHistoryInfo()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '90%', margin: '1rem' }}
                                        text={'Performance Comments'}
                                        disabled={canViewPerformanceComments()}
                                        onClick={() => showPerformanceComments()}
                                    />
                                </Panel>
                            </Panel>
                        </div>
                    </Page.Section>}
                    {selectedPersonnel && <Page.Section width={10}>
                        <div style={{ height: '803px' }}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel
                                    panelTitle={
                                        selectedPersonnel && selectedPersonnel?.tsdNo ?
                                            `Personnel Data - ${selectedPersonnel?.akaName ? selectedPersonnel?.akaName : selectedPersonnel?.fName + ' ' + selectedPersonnel?.lName}` :
                                            'Personnel Data'
                                    }
                                >
                                    <div id="formContent" style={{ overflowY: 'scroll' }} className={isCollapsed ? 'large-panel' : 'large-panel-with-search'}>
                                        <div className="form">
                                            <div ref={topOfPage}>
                                                <div style={{ display: 'flex', marginBottom: '2rem' }}>
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '24%' }}
                                                        style={{ width: '100%' }}
                                                        name="fName"
                                                        label="First Name"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '24%' }}
                                                        style={{ width: '100%' }}
                                                        name="mName"
                                                        label="Middle Name"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '24%' }}
                                                        style={{ width: '100%' }}
                                                        name="lName"
                                                        label="Last Name"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '24%' }}
                                                        style={{ width: '100%' }}
                                                        name="akaName"
                                                        label="A/K/A"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                </div>
                                                <div style={{ display: 'flex', marginTop: '1rem', marginBottom: '2rem' }}>
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '50%' }}
                                                        style={{ width: '100%' }}
                                                        name="corpName"
                                                        label="Corporation Name"
                                                        className="lh-half-width"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                </div>
                                            </div>

                                            <CollapsibleSection title="Contact Info and Permanent Address" startCollapsed={true}>
                                                <div style={{ marginBottom: '4rem' }}>
                                                    <div style={{ display: 'flex' }}>
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '49%' }}
                                                            style={{ width: '100%' }}
                                                            name="email1"
                                                            label="Primary Email"
                                                            className="lh-half-width"
                                                            register={register}
                                                            errors={errors}
                                                        />
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '49%' }}
                                                            style={{ width: '100%' }}
                                                            name="email2"
                                                            label="Secondary Email"
                                                            className="lh-half-width"
                                                            register={register}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div style={{ display: 'flex', marginTop: '1rem', marginBottom: '4rem' }}>
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '50%' }}
                                                            style={{ width: '100%' }}
                                                            name="homePh"
                                                            label="Home Phone Number"
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            onBlur={() => formatPhoneNumber('homePh')}
                                                        />
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '50%' }}
                                                            style={{ width: '100%' }}
                                                            name="cellular"
                                                            label="Cell Phone Number"
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            onBlur={() => formatPhoneNumber('cellular')}
                                                        />
                                                        {/* {<RHFInputBox
                                                            bodyStyle={{ width: '33%' }}
                                                            style={{ width: '100%' }}
                                                            name="fax"
                                                            label="Fax"
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            onBlur={() => formatPhoneNumber('cellPhoneNumber')}
                                                        /> */}
                                                    </div>
                                                    {/*<div style={{ display: 'flex', marginTop: '1rem', marginBottom: '2rem' }}>
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '33%' }}
                                                            style={{ width: '100%' }}
                                                            name="offPh"
                                                            label="Office Phone Number"
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            onBlur={() => formatPhoneNumber('homePhoneNumber')}
                                                        />
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '33%' }}
                                                            style={{ width: '100%' }}
                                                            name="foPhone"
                                                            label="Field Office Phone Number"
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            onBlur={() => formatPhoneNumber('homePhoneNumber')}
                                                        />
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '33%' }}
                                                            style={{ width: '100%' }}
                                                            name="fHPhone"
                                                            label="Field Hotel Phone Number"
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            onBlur={() => formatPhoneNumber('cellPhoneNumber')}
                                                        />
                                                    </div>
                                                    <div style={{ display: 'flex', marginTop: '1rem', marginBottom: '4rem' }}>
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '33%' }}
                                                            style={{ width: '100%' }}
                                                            name="pager"
                                                            label="Pager"
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            onBlur={() => formatPhoneNumber('homePhoneNumber')}
                                                        />
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '33%' }}
                                                            style={{ width: '100%' }}
                                                            name="oTHPhone"
                                                            label="Other Phone Number"
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            onBlur={() => formatPhoneNumber('cellPhoneNumber')}
                                                        />
                                                    </div> */}
                                                    <div style={{ marginBottom: '2rem' }}>
                                                        <div style={{ display: 'flex' }}>
                                                            <RHFInputBox
                                                                bodyStyle={{ width: '49%' }}
                                                                style={{ width: '100%' }}
                                                                name="addr1"
                                                                label="Address Line 1"
                                                                className="lh-half-width"
                                                                register={register}
                                                                errors={errors}
                                                            />
                                                            <RHFInputBox
                                                                bodyStyle={{ width: '49%' }}
                                                                style={{ width: '100%' }}
                                                                name="addr2"
                                                                label="Address Line 2"
                                                                className="lh-half-width"
                                                                register={register}
                                                                errors={errors}
                                                            />
                                                        </div>
                                                        <div style={{ marginTop: '1rem', display: 'flex' }}>
                                                            <RHFInputBox
                                                                bodyStyle={{ width: '32.4%' }}
                                                                style={{ width: '100%' }}
                                                                name="zip1"
                                                                label="Zip Code"
                                                                className="lh-third-width"
                                                                register={register}
                                                                errors={errors}
                                                                onChange={handleZipcodeChange}
                                                            />
                                                            <RHFInputBox
                                                                bodyStyle={{ width: '32.3%' }}
                                                                style={{ width: '100%' }}
                                                                name="city"
                                                                label="City"
                                                                className="lh-third-width"
                                                                register={register}
                                                                errors={errors}
                                                            />
                                                            <RHFSelect
                                                                bodyStyle={{ width: '32.3%' }}
                                                                style={{ width: '100%' }}
                                                                name="state"
                                                                label="State"
                                                                options={stateDropdownOptions()}
                                                                register={register}
                                                                errors={errors}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </CollapsibleSection>

                                            <CollapsibleSection title="Mailing Address" startCollapsed={true}>

                                                <div style={{ marginTop: '1rem', display: 'flex' }}>
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '49%' }}
                                                        style={{ width: '100%' }}
                                                        name="offAddr1"
                                                        label="Address Line 1"
                                                        className="lh-half-width"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '49%' }}
                                                        style={{ width: '100%' }}
                                                        name="offAddr2"
                                                        label="Address Line 2"
                                                        className="lh-half-width"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                </div>
                                                <div style={{ marginTop: '1rem', marginBottom: '2rem', display: 'flex' }}>
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '32.4%' }}
                                                        style={{ width: '100%' }}
                                                        name="offZip1"
                                                        label="Zip Code"
                                                        className="lh-third-width"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '32.3%' }}
                                                        style={{ width: '100%' }}
                                                        name="offCity"
                                                        label="City"
                                                        className="lh-third-width"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFSelect
                                                        bodyStyle={{ width: '32.3%' }}
                                                        style={{ width: '100%' }}
                                                        name="offState"
                                                        label="State"
                                                        options={stateDropdownOptions()}
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                </div>
                                            </CollapsibleSection>

                                            <CollapsibleSection title="Emergency Contact" startCollapsed={true}>
                                                <div style={{ display: 'flex', marginBottom: '2rem' }}>
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '50%' }}
                                                        style={{ width: '100%' }}
                                                        name="contact"
                                                        label="Emergency Contact Name"
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFInputBox
                                                        bodyStyle={{ width: '50%' }}
                                                        style={{ width: '100%' }}
                                                        name="emergencyPh"
                                                        label="Emergency Contact Phone"
                                                        register={register}
                                                        errors={errors}
                                                        onBlur={() => formatPhoneNumber('emergencyPh')}
                                                    />
                                                </div>
                                            </CollapsibleSection>

                                            <CollapsibleSection title="Hiring Information" startCollapsed={true}>
                                                <div style={{ marginTop: '1rem', display: 'flex' }}>

                                                    <div style={{ width: '32.3%', paddingRight: '5px' }}>
                                                        <label>Hired By</label>
                                                        <Controller
                                                            name="hireBy"
                                                            control={control}
                                                            render={({ onChange, onBlur, value }) => (
                                                                <Select
                                                                    onBlur={onBlur}
                                                                    onChange={(option) => onChange(option?.value || null)}
                                                                    value={managerList?.find(m => m.value === value) || null}
                                                                    options={managerList}
                                                                    isSearchable={true}
                                                                    placeholder="Hired By"
                                                                    styles={customStyles}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                    <RHFSelect
                                                        bodyStyle={{ width: '32.3%' }}
                                                        style={{ width: '100%' }}
                                                        name="haspKey"
                                                        label="Employee Type"
                                                        options={[
                                                            { value: 'FULL', label: 'Full-Time' },
                                                            { value: 'PART', label: 'Part-Time' },
                                                            { value: 'TEMP', label: 'Temporary' },
                                                            { value: 'SEAS', label: 'Seasonal' },
                                                        ]}
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                    <RHFSelect
                                                        bodyStyle={{ width: '32.3%' }}
                                                        style={{ width: '100%' }}
                                                        name="contractorPayType"
                                                        label="T&E Entry Method"
                                                        options={[
                                                            { value: 'D', label: 'By Day' },
                                                            { value: 'H', label: 'By Hour' },
                                                        ]}
                                                        register={register}
                                                        errors={errors}
                                                    />
                                                </div>
                                                <div style={{ marginTop: '1rem', display: 'flex' }}>
                                                    <RHFInputBox
                                                        label="Hire Date"
                                                        name={`hireDate`}
                                                        type="date"
                                                        register={register}
                                                        errors={errors}
                                                        style={{ width: '100%' }}
                                                        bodyStyle={{ width: '32.3%' }}
                                                    />
                                                    <RHFInputBox
                                                        label="Last Worked"
                                                        name={`lastWorkedInfo.lastWorkDate`}
                                                        type="date"
                                                        register={register}
                                                        errors={errors}
                                                        style={{ width: '100%' }}
                                                        bodyStyle={{ width: '32.3%' }}
                                                    />
                                                    <RHFInputBox
                                                        label="Entered / Updated"
                                                        name={`modDate`}
                                                        type="date"
                                                        register={register}
                                                        errors={errors}
                                                        style={{ width: '100%' }}
                                                        bodyStyle={{ width: '32.3%' }}
                                                    />
                                                </div>
                                                <div style={{ marginTop: '1rem', display: 'flex' }}>
                                                    <RHFInputBox
                                                        label="PTO Renewal Date"
                                                        name={`haspIn`}
                                                        type="date"
                                                        register={register}
                                                        errors={errors}
                                                        style={{ width: '100%' }}
                                                        bodyStyle={{ width: '32.3%' }}
                                                    />
                                                    <div className="dialog-form-row" style={{ verticalAlign: 'middle', justifyContent: 'right', width: '32.3%' }}>
                                                        <RHFInputBox
                                                            label="Last Termination Date"
                                                            name={`termDate`}
                                                            type="date"
                                                            register={register}
                                                            errors={errors}
                                                            style={{ width: '100%' }}
                                                            bodyStyle={{ width: '32.3%' }}
                                                            disabled={true}
                                                        />
                                                        <a onClick={() => showTermRehireDateDialog('Termination')}>
                                                            <i style={{ marginLeft: 'auto', fontSize: '1.5rem' }} className="far fa-edit mr-1 clickable" />
                                                        </a>
                                                    </div>
                                                    <div className="dialog-form-row" style={{ verticalAlign: 'middle', justifyContent: 'right', width: '32.3%' }}>
                                                        <RHFInputBox
                                                            label="Last Rehire Date"
                                                            name={`rH1Date`}
                                                            type="date"
                                                            register={register}
                                                            errors={errors}
                                                            style={{ width: '100%' }}
                                                            bodyStyle={{ width: '32.3%' }}
                                                            disabled={true}
                                                        />
                                                        <a onClick={() => showTermRehireDateDialog('Rehire')}>
                                                            <i style={{ marginLeft: 'auto', fontSize: '1.5rem' }} className="far fa-edit mr-1 clickable" />
                                                        </a>
                                                    </div>
                                                </div>
                                                {/* <div style={{ marginTop: '1rem', display: 'flex' }}>
                                                    
                                                    <RHFInputBox
                                                        label="Rehire Date 2"
                                                        name={`rH2Date`}
                                                        type="date"
                                                        register={register}
                                                        errors={errors}
                                                        style={{ width: '100%' }}
                                                        bodyStyle={{ width: '32.3%' }}
                                                    />
                                                    <RHFInputBox
                                                        label="Rehire Date 3"
                                                        name={`rH3Date`}
                                                        type="date"
                                                        register={register}
                                                        errors={errors}
                                                        style={{ width: '100%' }}
                                                        bodyStyle={{ width: '32.3%' }}
                                                    />
                                                </div> */}
                                                <div style={{ marginTop: '1rem', marginBottom: '2rem' }}>
                                                    <div style={{ width: '32.3%' }}>
                                                        <RHFCheckbox
                                                            name="jobCategory"
                                                            label="Billable?"
                                                            style={{ verticalAlign: 'middle' }}
                                                            register={register}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div style={{ width: '32.3%' }}>
                                                        <RHFCheckbox
                                                            name="inelligible"
                                                            label="Inelligible For Rehire?"
                                                            style={{ verticalAlign: 'middle' }}
                                                            register={register}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                </div>
                                            </CollapsibleSection>

                                            <CollapsibleSection title="Current Work Location" startCollapsed={true}>
                                                <div style={{ marginBottom: '2rem' }}>
                                                    <div style={{ display: 'flex' }}>
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '32.4%' }}
                                                            style={{ width: '100%' }}
                                                            name="lastWorkedInfo.lastPeriod"
                                                            label="Last Period"
                                                            register={register}
                                                            errors={errors}
                                                            disabled={true}
                                                        />
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '15.7%' }}
                                                            style={{ width: '100%' }}
                                                            name="lastWorkedInfo.lastClNo"
                                                            label="Prospect"
                                                            register={register}
                                                            errors={errors}
                                                            disabled={true}
                                                        />
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '15.6%' }}
                                                            style={{ width: '100%' }}
                                                            name="lastWorkedInfo.lastPrNo"
                                                            label=" "
                                                            register={register}
                                                            errors={errors}
                                                            disabled={true}
                                                        />
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '32.4%' }}
                                                            style={{ width: '100%' }}
                                                            name="lastWorkedInfo.lastManager"
                                                            label="Manager"
                                                            register={register}
                                                            errors={errors}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div style={{ marginTop: '1rem', marginBottom: '2rem', display: 'flex' }}>
                                                        <RHFInputBox
                                                            bodyStyle={{ width: '32.3%' }}
                                                            style={{ width: '100%' }}
                                                            name="lastWorkedInfo.lastCounty"
                                                            label="Location"
                                                            register={register}
                                                            errors={errors}
                                                            disabled={true}
                                                        />
                                                        <RHFSelect
                                                            bodyStyle={{ width: '32.3%' }}
                                                            style={{ width: '100%' }}
                                                            name="billingOffice"
                                                            label="Billing Office"
                                                            options={billingOfficeDropdown()}
                                                            register={register}
                                                            errors={errors}
                                                        />
                                                        <div style={{ width: '32.3%' }}>
                                                            <RHFCheckbox
                                                                name="omitTeServices"
                                                                label="Omit Services on Online Time Sheet?"
                                                                style={{ verticalAlign: 'middle' }}
                                                                register={register}
                                                                errors={errors}
                                                            />
                                                            <RHFCheckbox
                                                                name="omitTsCorpName"
                                                                label="Omit Corp. Name on Online Time Sheet?"
                                                                style={{ verticalAlign: 'middle' }}
                                                                register={register}
                                                                errors={errors}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ border: '1px outset', padding: '1rem', marginBottom: '2rem', marginTop: '2rem', marginRight: '.5rem', background: '#EFF4F8' }}>
                                                    i: Omit Services will hide the services on the time sheet
                                                    and send the direct deposit email to the second email address.
                                                </div>
                                            </CollapsibleSection>

                                            {/* <CollapsibleSection title="Employee Info" startCollapsed={true}>
                                                <div style={{ marginBottom: '2rem' }}>
                                                    <div style={{ marginBottom: '4rem' }}>
                                                        <RHFSelect
                                                            bodyStyle={{ width: '32.3%' }}
                                                            style={{ width: '100%' }}
                                                            name="deptNo"
                                                            label="Department"
                                                            options={departmentsDropdown()}
                                                            register={register}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div style={{ marginBottom: '2rem' }}>
                                                        <div className="form-row">
                                                            <RHFSelect
                                                                bodyStyle={{ width: '32.3%' }}
                                                                style={{ width: '100%' }}
                                                                name="office1Name"
                                                                label="Office"
                                                                options={officeDropdown()}
                                                                register={register}
                                                                onChange={(e) => toggleFirstOffice(e)}
                                                                errors={errors}
                                                            />
                                                            <RHFInputBox
                                                                bodyStyle={{ width: '32.3%' }}
                                                                style={{ width: '100%' }}
                                                                name="office1Ext"
                                                                label="Extension"
                                                                register={register}
                                                                errors={errors}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{ marginBottom: '2rem' }}>
                                                        <div className="form-row">
                                                            <RHFSelect
                                                                bodyStyle={{ width: '32.3%' }}
                                                                style={{ width: '100%' }}
                                                                name="office2Name"
                                                                label=" "
                                                                options={officeDropdown()}
                                                                onChange={(e) => toggleSecondOffice(e)}
                                                                register={register}
                                                                errors={errors}
                                                                disabled={!hasFirstOffice}
                                                            />
                                                            <RHFInputBox
                                                                bodyStyle={{ width: '32.3%' }}
                                                                style={{ width: '100%' }}
                                                                name="office2Ext"
                                                                label=" "
                                                                register={register}
                                                                errors={errors}
                                                                disabled={!hasFirstOffice}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </CollapsibleSection> */}
                                            <div ref={bottomOfPage} />
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </div>
                    </Page.Section>}
                    {!selectedPersonnel && <Page.Section width={12}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel>
                                <div>
                                    <div className="bold-centered">No Personnel Selected</div>
                                    <div style={{ textAlign: 'center' }}>
                                        <Button
                                            className="blue-hover-button"
                                            text="Add Personnel"
                                            onClick={() => addPersonnel()}
                                            style={{ width: '20rem', marginBottom: '1rem' }}
                                        />
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>}
                </Page>
            </form>
            <AddPersonnelDialog
                dialogName={DialogList.ADD_PERSONNEL}
                hideDialog={hideDialog}
                setSelectedPersonnel={setSelectedPersonnel}
            />
            <PersonnelTaxInformationDialog
                dialogName={DialogList.PERSONNEL_TAX_INFORMATION}
                selectedPersonnel={selectedPersonnelProp ?? selectedPersonnel}
                stateInfo={states}
                hideDialog={hideDialog}
                showToast={showToast}
            />
            <PersonnelCommentDialog
                dialogName={DialogList.PERSONNEL_PERFORMANCE_COMMENTS}
                selectedPersonnel={selectedPersonnelProp ?? selectedPersonnel}
                hideDialog={hideDialog}
            />
            <PersonnelHiringHistoryDialog
                dialogName={DialogList.PERSONNEL_HIRING_HISTORY}
                selectedPersonnel={selectedPersonnelProp ?? selectedPersonnel}
                hideDialog={hideDialog}
                personnelHiringHistory={personnelHiringHistory}
                refreshHiringHistory={getHiringHistory}
            />
            <PersonnelAdvancedQuickFind
                dialogName={DialogList.PERSONNEL_ADVANCED_QUICK_FIND}
                selectedPersonnel={selectedPersonnelProp ?? selectedPersonnel}
                selectPersonnel={setSelectedPersonnel}
                hideDialog={hideDialog}
            />
            <UpdateTermHireDateDialog
                dialogName={DialogList.UPDATE_TERM_HIRE_DATE}
                context={dateDialogContextProp}
                oldDate={prevDateProp}
                hideDialog={finalizeTermRehireUpdate}
                selectedPersonnel={selectedPersonnelProp ?? selectedPersonnel}
            />
        </div >
    );
    // END OF PAGE
};

export default PersonnelPage;



// WEBPACK FOOTER //
// ./src/components/personnel/pages/PersonnelPage.tsx